import { gql } from '@apollo/client';

import { ProfessorActivity, ActivityInput } from '../../types';
import { professorActivityFragment } from '../fragments';

export interface UpdateActivityMutationVariables {
  courseId: string;
  activityId: string;
  input: ActivityInput;
}

export interface UpdateActivityMutationResult {
  activity: ProfessorActivity;
}

export const updateActivityMutation = gql`
  mutation UpdateActivity($courseId: String!, $activityId: String!, $input: UpdateActivityInput!) {
    activity(courseId: $courseId, activityId: $activityId, input: $input)
      @rest(type: "Activity", path: "courses/{args.courseId}/activities/{args.activityId}", method: "PUT") {
      ...ProfessorActivity
    }
  }
  ${professorActivityFragment}
`;
